import { render, staticRenderFns } from "./cubage.vue?vue&type=template&id=05cf802c&"
import script from "./cubage.vue?vue&type=script&lang=js&"
export * from "./cubage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05cf802c')) {
      api.createRecord('05cf802c', component.options)
    } else {
      api.reload('05cf802c', component.options)
    }
    module.hot.accept("./cubage.vue?vue&type=template&id=05cf802c&", function () {
      api.rerender('05cf802c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/mbl/cubage.vue"
export default component.exports